export const AppQueryParams = {
  Language: 'language',
  UserToken: 'userToken',
  Platform: 'platform',
  AppVersion: 'appVersion',
  DeviceId: 'deviceId',
  AppSection: 'appSection',
  DismissShop: 'dismissShop',
  OngoingTransaction: 'ongoingTransaction',
  ShopId: 'shopId',
  ProductId: 'productId',
  PaymentOption: 'payment',
};
